import React, { useEffect, useState, useContext } from 'react';
import { Redirect, Route } from "react-router-dom";
import { withTracker } from "../../hoc/withTracker";
import storage from '@fci/business-layer/storage';
import { token } from '@fci/business-layer/constants';
import { AuthLayout, PublicLayout } from "..";
import { UserContext } from "../../UserContext";
import { withApollo } from "react-apollo";

const getUserAuth = () => {
    return storage.getItem(token);
};
const RouteWrapper = ({
    component: Component,
    isPrivate,
    ...rest
}) => {
    const [hasAcceptedTerms, setHasAcceptedTerms] = useState(true);
    const isAuth = getUserAuth();
    const { user } = useContext(UserContext);

    useEffect(() => {
        if (!isAuth) return;

        if (user && user.hasAcceptCondition !== undefined) {
            setHasAcceptedTerms(user.hasAcceptCondition);
        }
    }, [isAuth, user]);

    /**
     * Redirect the user to the Login page if it is not authorized,
     * or Redirect the user after login to the terms page if the terms are not accepted
     *
     */
    if (isPrivate && (!isAuth || !hasAcceptedTerms)) {
        return <Redirect to="/login" />;
    }

    if (!isPrivate && !!isAuth && !!hasAcceptedTerms) {
        return <Redirect to="/" />;
    }

    const Layout = (!!isAuth && !!hasAcceptedTerms) ? AuthLayout : PublicLayout;

    return (
        <Route
            {...rest}
            render={props => (
                <Layout>
                    <Component {...props}
                               setHasAcceptedTerms={setHasAcceptedTerms}
                               hasAcceptedTerms={hasAcceptedTerms}/>
                </Layout>
            )}
        />
    );
}
export default withTracker(withApollo(RouteWrapper));

RouteWrapper.defaultProps = {
    isPrivate: false,
};
